/**
 * Pretty-prints a JSON string with the given indent.
 * Returns the original value unchanged if it's empty or invalid JSON.
 */
export const formatJson = (value, indent = 2) => {
  const trimmed = value?.trim();
  if (!trimmed) return value;

  try {
    return JSON.stringify(JSON.parse(trimmed), null, indent);
  } catch {
    return value;
  }
};

/**
 * Returns true if the given string is valid JSON. Empty/whitespace returns true
 * (callers can decide whether empty is allowed).
 */
export const isValidJson = (value) => {
  const trimmed = value?.trim();
  if (!trimmed) return true;

  try {
    JSON.parse(trimmed);
    return true;
  } catch {
    return false;
  }
};
